import axios from "axios";
import * as Sentry from "@sentry/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Report meaningful API failures (5xx + network errors) to Sentry with HTTP
// context. 4xx is expected control flow (validation, auth, payment-required)
// and would create noise, so we skip it.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const isNetworkErr = !error.response;
    if (isNetworkErr || (status && status >= 500)) {
      Sentry.withScope((scope) => {
        scope.setTag("http.status_code", String(status || "network"));
        scope.setTag("http.url", error.config?.url || "unknown");
        scope.setContext("axios", {
          method: error.config?.method,
          url: error.config?.url,
          status,
          response_detail: (error.response?.data?.detail || "").toString().slice(0, 240),
        });
        Sentry.captureException(error);
      });
    }
    return Promise.reject(error);
  },
);

export default api;
